
require('./header.scss');
const Util = require('../../util');
const loginModel = require('../../loginModel/login');
const CloseWebPage = require('../../util.js').CloseWebPage;


const VACATION_PRODUCT_SESSION_KEY = 'FZG_SHOW_VACATION_PRODUCT';

function applyVacationProductMenu(isShow) {
    if (isShow) {
        $('.vacation-product-menu').show();
    } else {
        $('.vacation-product-menu').hide();
    }
}

function applyVacationProductMenuFromSession() {
    try {
        if (sessionStorage.getItem(VACATION_PRODUCT_SESSION_KEY) === 'true') {
            applyVacationProductMenu(true);
            return true;
        }
    } catch (e) {}
    return false;
}

// 优先读 session，无缓存再调接口；接口返回 true 时写入 session
function toggleVacationProductMenu() {
    if (applyVacationProductMenuFromSession()) {
        return;
    }

    $.post('/myinfo/selectShowVacationProduct.do', {}, function (res) {
        const isShow = res && res.result === true;
        if (isShow) {
            try {
                sessionStorage.setItem(VACATION_PRODUCT_SESSION_KEY, 'true');
            } catch (e) {}
        }
        applyVacationProductMenu(isShow);
    }, 'noAnimation');
}

// 模块加载后尽早根据 session 恢复菜单，减少切换页面闪烁
if (typeof $ !== 'undefined') {
    applyVacationProductMenuFromSession();
}

// 获取当前用户信息
function getCurUser(pagename){

	//根据传入的页面名称，改变对应的板块样式
    $('.i-t-n-group').find('li[data-module="' + pagename + '"]').attr('checked','checked');

	$.post('/user/getCurrentUser.do', {}, function (res) {
		if( res.returnCode == 1 ){
            //用户已经登录
            getSales();

            $('.i-t-n-user-wrap').hover(function () {
                //隐藏个人信息的下拉列表
                $('.i-t-n-user-wrap:hover .i-t-n-drops').css('display','none');
            })
			//将用户已登录的信息赋值给window
			window.hasLoginFzg = 'true';
            //添加icon
            let noticeHtml = `
            <a href="/myinfo/toMyInfoHome.do?index=17" class="link-href-a">
                <div class="gonggao-icon"></div>
            </a>
            `
            $('.notice-icon-container').append(noticeHtml)

			window.distrbCode = res.data.distributorAccount.distrbCode;
			window.isAdmin = res.data.user.isAdmin;
			if(res.data.temporaryDemand1470){
				window.temporaryDemand1470 = JSON.parse(res.data.temporaryDemand1470)
			}

			if(window.isAdmin == null)	window.isAdmin = 'null';

			$(".i-t-n-user")
				.html(res.data.user.customerUserName)
				.attr('data-distrbid', res.data.distributorAccount.distrbId)
				.attr('data-type', res.data.user.type)
				.attr('data-suppid', res.data.user.suppId)
				.attr('data-isadmin', res.data.user.isAdmin);
			sessionStorage.setItem('login','login');    // 老页面用到这个东西，所以为了兼容...


            if (pagename === 'toolDataIn'){
                //如果是房掌柜小助手基础数据导入页面，则不允许客户编号为SZ2747以外的人进入
                if (res.data.distributorAccount.distrbCode.toUpperCase() !== 'SZ2747'){
                    alert('您不被允许进入该页面',{
                        closeBtn : 0
                    },function () {
                        CloseWebPage();
                    });
                }

            }else if (pagename === 'toolOperateHotel'){
            	if (res.data.user.isAdmin !== 1){
                    alert('您不被允许进入该页面',{
                        closeBtn : 0
                    },function () {
                        CloseWebPage();
                    });
	            }
            }
            
            if (res.data.isFirstLoginAfterRegister){
            	require('../../customizePrompt/customizePrompt')();
            }
		}else if( res.returnCode == -400001 ){
			//将用户未登录的信息赋值给window
			window.hasLoginFzg = 'false';
            //添加icon
            let noticeHtml = `
            <div class="gonggao-icon is-link-show"></div>
            `
            $('.notice-icon-container').append(noticeHtml)

			//隐藏订单管理模块
			$('.index-concern-order-outer').css('display','none');
			//隐藏价格条
			$('.need-to-hide-without-login').hide();

			if (pagename === 'index' || pagename === 'register' || pagename === 'noLogin' || pagename === 'hotelList2' || pagename === 'ticket' || pagename === 'groupRoom' || pagename === 'package'){

				$('.i-t-n-triangle').hide();

				//如果是首页或注册页，或者为不需要进行登录验证的界面，则不做登录检测,用户点击“您好，请登录”时，弹出登录框
				$('.i-t-n-user-wrap').hover(function () {
					//隐藏个人信息的下拉列表
					$('.i-t-n-user-wrap:hover .i-t-n-drop').css('display','none');
				}).click(function () {
					// 登录组件
					require('../../loginBox/loginBox.js')();
				});


			}else{
				Util.login();
			}

		}
	}, 'noAnimation');

}

// 获取专属销售顾问
function getSales() {
    $.post('/myinfo/getMyInfo.do', {salesman: 1}, function(res) {
        if(res.returnCode == 1) {
            let html = `
                <div class="number-css">
                    <div class="bold-css">专属销售经理：</div>
                </div>
                <div class="lianxi-all">
                    <div class="lianxi-ren">
                        <div class="people-icon"></div>
                        <div class="concat-over">${res.data.salesman.realname || " -"}</div>
                    </div>
                    <div class="lianxi-ren">
                        <div class="phone-icon"></div>
                        <div class="concat-over">${res.data.salesman.cellphone || " -"}</div>
                    </div>
                    <div class="lianxi-ren">
                        <div class="email-icon"></div>
                        <div class="concat-over">${res.data.salesman.email || " -"}</div>
                    </div>
                </div>
            `
            $(".mySalesMan").append(html);
        } else {

        }
    },"noAnimation")
}

// 初始化退出事件
function initLogout(){
    $("#logout").on('click', function(){
        var loginoutConfirm = confirm('是否确定退出？', function(){
            $.post('/user/loginoutfzg.do', {}, function (res) {
                if( res && res.returnCode == 1 ){
	                $(".i-t-n-user").html("请登录");
                    layer.close(loginoutConfirm);
                    location.reload();
                }
            })
        })
    })
}


//在导航栏三个入口处加一个登录判断
function navbarLink() {
	$('.i-t-n-group>li[name="i-t-n-radio"]>a').click(function () {
		if ($(this).attr('data-module') === 'group'){
			// 登录组件
			require('../../loginBox/loginBox.js')();

			return false;
		}

	})
}

function initClick() {
    $('.i-t-n-drops').click(function(event) {
        window.open("http://en-cn.jl-tour.com/");
        event.stopPropagation();
        event.preventDefault(); 
    })
}

// 点击公告 - 跳转个人中心
function clickNoticeIcon() {
    $(document).delegate(".is-link-show","click",function() {
        layer.msg('请先登录');
        // 登录组件
        window.setTimeout(() => {
            require('../../loginBox/loginBox.js')();
        },1000)
    })
}

// 首页 顶部导航栏 区域相关 js
module.exports = {
    run: function(pagename){
        //跳转英文版
        // initClick();

        // 度假产品菜单显隐
        toggleVacationProductMenu();

        // 获取当前用户信息
        getCurUser(pagename);

        // 初始化退出事件
        initLogout();

		//在导航栏三个入口处加一个登录判断
	    navbarLink();

        // 未登录 - 点击公告
        clickNoticeIcon();

    }
}



// WEBPACK FOOTER //
// ./src/common/layout/header/header.js